import React from 'react';

import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'segments/hooks';

import { LoginRequest, useLoginMutation } from '../../store/authApi';
import { selectLoginError } from '../../store/authSlice';

import './SignInForm.scss';

const SignInForm: React.FC = () => {
  const { t } = useTranslation();

  const [login] = useLoginMutation();
  const errors = useAppSelector(selectLoginError);

  const onFinish = (values: LoginRequest) => {
    login(values);
  };
  return (
    <Form
      name="normal_login"
      className="login-form"
      initialValues={{ remember: true }}
      onFinish={onFinish}
    >
      <h2 className="login-form__title">{t('login')}</h2>
      {errors.common && <p className="login-form__error-message">{errors.common}</p>}
      <Form.Item
        name="email"
        rules={[{ required: true, message: 'Please input your Username!' }]}
      >
        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: 'Please input your Password!' }]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="Password"
          className="input"
        />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t('login', 'Вход')}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SignInForm;
